"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PollingJsonRpcProvider = void 0;
const ethers_1 = require("ethers");
/**
 * Uses a setting in JsonRpcProvider to poll for events,
 * rather than using sparsely-implemented eth_filter events.
 */
class PollingJsonRpcProvider extends ethers_1.JsonRpcProvider {
    constructor(url, chainId, pollingInterval = 10000, maxLogsPerBatch = 100) {
        const network = ethers_1.Network.from(chainId);
        const options = {
            polling: true,
            staticNetwork: network,
            batchMaxCount: maxLogsPerBatch,
        };
        super(url, network, options);
        this.isPollingProvider = true;
        this.pollingInterval = pollingInterval;
    }
}
exports.PollingJsonRpcProvider = PollingJsonRpcProvider;
